export default {
  NO_ASSIGNED_SECTION: 'no_assigned_section'
}
